module.exports = "/assets/ced67f1f411923dbd10edc1f517ca4cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/MS.png
// module id = 1625
// module chunks = 0